export const formatTestIds = (testIds: string[] = []): number[] =>
    testIds.reduce<number[]>((acc, testId) => {
        const numTestId = Number(testId);
        if (Number.isInteger(numTestId)) {
            acc.push(numTestId);
        }
        return acc;
    }, []);
